<template lang="html">
<div>
  <article v-if="medicamentos.length == 0" id="info">
    <vx-card title="Medicamentos" subtitle="">
      <h6>Usuário ainda não possui registros de medicamentos</h6>
    </vx-card>
  </article>

  <article v-if="medicamentos.length > 0" v-show="medicine" id="medicine">
    <vx-card title="Prescritos" subtitle="Selecione os medicamentos que deseja obter informação">
      <div>
        <vs-row>
          <!-- <vs-col vs-w="12">
          <button @click="getGeolocation()" class="button-default">Localização atual</button>
        </vs-col> -->
          <vs-col type="flex" vs-align="center" vs-justify="flex-start" vs-lg="12" vs-sm="12" vs-xs="12" v-if="address">
            <h6 class="address-user">{{address}} - CEP: {{cep}}</h6>
          </vs-col>
          <vs-col type="flex" vs-align="center" vs-justify="flex-start" vs-lg="4" vs-sm="6" vs-xs="12">
            <div class="input-cep">
              <vs-input label-placeholder="Buscar por novo cep" v-model="cepSearch" :danger="cepInvalid" danger-text="Encontramos um problema com o CEP" :maxlength="9" v-mask="['#####-###']" />
              <vs-button color="warning" type="border" icon="public" class="button-search" v-on:click="searchAddress"></vs-button>
            </div>
          </vs-col>
          <vs-col type="flex" vs-align="center" vs-justify="flex-start" vs-lg="4" vs-sm="6" vs-xs="12">
            <div class="input-cep">
              <label class="margin-label">Buscar localização atual :</label>
              <vs-button color="warning" type="border" icon="my_location" class="button-search-location" @click="getGeolocation()"></vs-button>
            </div>
          </vs-col>
        </vs-row>

        <vs-table stripe multiple search v-model="selected" pagination max-items="9" :data="medicamentos">
          <template slot="thead">
            <vs-th>Selecionar todos:</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].activePrinciple">
                <strong>{{data[indextr].product}}</strong>
                <br />
                <small>{{ data[indextr].activePrinciple }}</small>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <vs-button class="search" type="border" color="warning" @click="getLatLng()" :disabled="selected.length < 1">Pesquisar
        </vs-button>

      </div>
    </vx-card>

  </article>

  <article v-show="phamacy" id="phamacy">
    <vx-card title="Farmácias" subtitle="Resultados da pesquisa">
      <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="flex-end" vs-w="12">
          <div class="align-right">
            <label for="order" class="search_area">Área de pesquisa: </label>

            <select placeholder="Selecione" class="input-select" id="order" v-model="order_distance">
              <option value="10">10 km</option>
              <option value="20">20 km</option>
              <option value="30">30 km</option>
              <option value="40">40 km</option>
              <option value="50">50 km</option>
              <option value="60">60 km</option>
              <option value="70">70 km</option>
              <option value="80">80 km</option>
              <option value="90">90 km</option>
              <option value="250">+ 100 km</option>
            </select>
          </div>
        </vs-col>
      </vs-row>
    </vx-card>

    <vs-divider />
    <vs-row vs-justify="center" :key="nome" v-for="(f, nome) in farmacias">
      <vs-card v-if="seePharmacy(f.distancia,order_distance)">
        <vs-row vs-justify="center">
          <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="8" vs-xs="12">
            <div>
              <vs-row>
                <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                  <h4>{{ f.nome }}</h4> <br>
                </vs-col>

                <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="8" vs-xs="12">
                  <p style="word-break: break-word;">{{ f.endereco }}</p> <br>
                </vs-col>
                <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                  <span class="distance">{{ f.distancia }} KM</span> <br>
                </vs-col>
              </vs-row>
              <vs-divider />

              <vs-collapse class="collapse-medicine">
                <vs-collapse-item>
                  <div slot="header">
                    <strong>Medicamentos</strong> <span class="info"> (clique para ver)</span>
                  </div>
                  <select placeholder="Selecione" class="input-select right-margin" id="order" @change="sortPharmacy(nome)" v-model="order">
                    <option value="ASC">Menor valor</option>
                    <option value="DESC">Maior valor</option>
                  </select>
                  <section :key="nome" v-for="(m, nome) in f.medicamentos" class="medicini-space">
                    <div class="tag-discount" v-if="m.porcentagemDesconto > 0">
                      <strong class="discount">{{ m.porcentagemDesconto }}%</strong>
                    </div>
                    <div class="content-discount">
                      <span class="text-medicine">{{ m.nome }}</span> <br>
                      <span>{{ m.nomeLaboratorio }}</span> <br>
                      <strong class="money">{{ maskMoney(m.preco) }}</strong> <br>
                    </div>
                  </section>

                </vs-collapse-item>
              </vs-collapse>
            </div>
          </vs-col>
          <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
            <!-- <iframe
            width="100%"
            height="240"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            :src="`https://maps.google.com/maps?q=${f.latitude},${f.longitude}&hl=pt-br&z=14&amp;output=embed`">
          </iframe> -->
            <gmap-map :center="googleMaps(f.latitude, f.longitude)" :zoom="15" style="width:100%;  height: 260px;">
              <gmap-marker :position="getPosition(f.latitude, f.longitude)"></gmap-marker>
            </gmap-map>

          </vs-col>
        </vs-row>
      </vs-card>
    </vs-row>

    <vs-row class="btn-voltar">
      <vs-button class="" color="#EB5424" @click="voltar()">Voltar
      </vs-button>
    </vs-row>

  </article>

</div>
</template>

<script>
document.getElementsByClassName("vs-table--search-input").placeholder =
  "Pesquisar medicamento";
import Modal from "@/components/modal-maps/modal.component.vue"
import { useStore } from "@/store/store.js"

export default {
  name: "medicine",
  components: {
    Modal
  },
  data: () => ({
    patient_id: "",
    geolocation: false,
    cepInvalid: false,
    cepValid: false,
    cepSearch: "",
    medicine: true,
    phamacy: false,
    selected: [],
    medicamentos: [],
    addres: [],
    cep: "",
    address: "",
    lat: "",
    lng: "",
    errorStr: "",
    gettingLocation: false,
    naoLocalizado: false,
    order: "ASC",
    order_distance: 250,
    show_input_cep: false,
    transitionName: "fade",
    farmacias: [],
    configs: {
      orderBy: "preco",
      order: "asc",
      filter: ""
    },
    bodyParameters: {}
  }),
  setup () {
    const store = useStore()

    return {
      getGoogleAddress: (cep) => store.dispatch("getGoogleAddress", cep),
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
    }
  },
  mounted: function () {
    const vm = this;
    vm.patient_id = vm.$session.get("id");
    vm.getMedicine();
    vm.getAddress();
  },
  methods: {
    getPosition(lat, lng) {
      return {
        lat: Number(lat),
        lng: Number(lng)
      };
    },
    googleMaps(lat, lng) {
      return {
        lat: Number(lat),
        lng: Number(lng)
      };
    },
    async searchAddress() {
      this.cepInvalid = false
      
      if (!this.cepInvalid) {
        const response = await this.getAddressByZipcode(this.cepSearch)
        this.cepInvalid = response && response.address

        if (!this.cepInvalid) {
          const { street, neighborhood, city, state } = response.address

          this.address = `${street}, ${neighborhood} - ${city} / ${state}`
        }
      }

      if (this.cepInvalid) {
        this.address = ""
        this.cepInvalid = true
      }
    },

    async getGeolocation() {
      if (!("geolocation" in navigator)) {
        this.errorStr = "Geolocalização não está habilitada."
      } else {
        this.gettingLocation = true

        await navigator.geolocation.getCurrentPosition(
          async ({ coords }) => {
            this.$vs.loading()

            if (coords && coords.latitude && coords.longitude) {
              const response = await this.getGoogleAddress({
                lat: coords.latitude,
                lng: coords.longitude,
              })

              if (response) {
                this.address = await response.formatted_address
                this.cep = await response.address_components
                  .find((addr) => (addr.types.includes("postal_code")))
                  .short_name
              }
            }
          },
          err => {
            this.gettingLocation = false;
            this.errorStr = err.message;
          }
        )

        this.$vs.loading.close()
      }
    },
    getMedicine() {
      const vm = this;
      vm.$vs.loading();

      this.axios
        .get(
          `${vm.$store.state.filooServer}orizon/${vm.patient_id}/medicine`
        )
        .then(response => {
          vm.medicamentos = response.data;
        })
        .finally(() => {
          vm.$vs.loading.close();
        });
    },

    getAddress() {
      const vm = this;
      vm.$vs.loading();

      this.axios
        .get(`${vm.$store.state.filooServer}orizon/address/${vm.patient_id}`)
        .then(response => {
          vm.addres = response.data[0];
          vm.cep = vm.addres.zipcode;
          vm.searchAddress();
        })
        .finally(() => {
          vm.$vs.loading.close();
        });
    },
    getLatLng() {
      const vm = this;
      if (vm.cep) {
        vm.$vs.loading();
        this.axios
          .get(
            "https://maps.googleapis.com/maps/api/geocode/json?address=" +
            vm.cep +
            "&key=AIzaSyAdwxi7P7SUDsbcxa3RRcQ315FDIOh1log"
          )
          .then(response => {
            vm.lat = JSON.stringify(
              response["data"].results[0].geometry.location.lat
            );
            vm.lng = JSON.stringify(
              response["data"].results[0].geometry.location.lng
            );
            vm.getPharmacy();
          });
      } else {
        vm.getPharmacy();
      }
    },
    getPharmacy() {
      const vm = this;
      vm.phamacy = true;
      vm.medicine = false;
      var lat;
      var lng;
      if (vm.cep != "") {
        lat = vm.lat;
        lng = vm.lng;
      } else {
        lat = vm.addres.latitude;
        lng = vm.addres.longitude;
      }
      vm.$vs.loading();
      this.axios
        .post(
          `${vm.$store.state.filooServer}orizon/farmacia/`,
          (vm.bodyParameters = {
            medicamentos: vm.selected.map(s =>
              vm.replaceSpecialChars(s.product)
            ),
            latitude: lat,
            longitude: lng
          })
        )
        .then(response => {
          var array = response.data;
          var result = [];

          for (var i = 0; i < array.length; i++) {
            array[i].distancia = array[i].distancia.replace(" km", "");
            result.push(array[i]);
          }

          vm.farmacias = result.sort((a, b) => a.distancia - b.distancia);
        })
        .finally(() => {
          vm.$vs.loading.close();
        });
    },

    replaceSpecialChars(str) {
      if (!str) return "";
      str = str.toLowerCase();
      var mapaAcentosHex = {
        a: /[\xE0-\xE6]/g,
        e: /[\xE8-\xEB]/g,
        i: /[\xEC-\xEF]/g,
        o: /[\xF2-\xF6]/g,
        u: /[\xF9-\xFC]/g,
        c: /\xE7/g,
        n: /\xF1/g
      };
      for (var letra in mapaAcentosHex) {
        var expressaoRegular = mapaAcentosHex[letra];
        str = str.replace(expressaoRegular, letra);
        //str = str.replace(/[' ']/,' ');
      }
      str = str.toUpperCase();
      return str;
    },

    maskMoney(value) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      });
      var newValue = parseFloat(value);
      var newValueFormat = formatter.format(newValue);
      return newValueFormat;
    },
    sortPharmacy(index) {
      var pharma = this.farmacias[index];
      pharma.medicamentos.sort(
        function (a, b) {
          if (this.order === "ASC") {
            return a.preco == b.preco ? 0 : a.preco > b.preco ? 1 : -1;
          } else if (this.order === "DESC") {
            return a.preco == b.preco ? 0 : a.preco < b.preco ? 1 : -1;
          }
        }.bind(this)
      );
    },

    seePharmacy(pharmacy, distance) {
      var exp = pharmacy.split(".");
      if (parseInt(exp[0]) <= parseInt(distance)) {
        return true;
      } else {
        return false;
      }
    },

    voltar() {
      const vm = this;
      vm.phamacy = false;
      vm.medicine = true;
      vm.farmacias = [];
    }
  }
};
</script>

<style>
.money {
  color: #fa9722;
}

.distance {
  background: #fa9722;
  padding: 5px;
  /* margin-top: 10px; */
  position: relative;
  border-radius: 50px;
  color: #fff;
  font-weight: 600;
  float: right;
  margin-top: 0.5%;
  font-size: 13px;
}

.tag-discount {
  width: 100px;
  background: #4db101;
  /* padding: 10px; */
  padding-top: 30px;
  height: 55px;
  padding-bottom: 15px;
  text-align: center;
  color: #fff;
  -ms-transform: rotate(20deg);
  -webkit-transform: rotate(20deg);
  transform: rotate(-40deg);
  position: absolute;
  margin-left: -42px;
  margin-top: -28px;
}

.input-default {
  width: 100%;
  border-radius: 2px;
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 15px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.input-select {
  padding: 8px;
  border-radius: 2px;
  border: 1px solid #ccc;
  cursor: pointer;
}

.search_area {
  margin-right: 10px;
}

.button-default {
  padding: 11px;
  margin-left: 0;
  border: 1px solid #ea8b50;
  color: #ea8b50;
  border-radius: 2px;
  background: none;
  font-size: 12px;
  margin-bottom: 15px;
  cursor: pointer;
}

@media only screen and (max-width: 414px) {
  .vs-table--content {
    width: 100%;
    overflow: hidden;
  }

  .vs-table--tbody-table {
    min-width: 280px;
    overflow: hidden;
  }

  .vs-con-table .vs-con-tbody {
    overflow: hidden;
  }
}

#order {
  margin-bottom: 15px;
}

.click-effect {
  background: #e56b1f;
  color: #fff;
  border-radius: 2px;
  font-size: 12px;
  padding: 10px;
  cursor: pointer;
  top: 8px;
  position: relative;
}

.content-discount {
  padding-left: 70px;
}

.no-margin {
  top: 0px !important;
}

.tabela {
  padding: 10px;
}

.btn-voltar {
  display: block !important;
  text-align: right;
}

.align-right {
  float: right;
}

.collapse-medicine.default {
  padding-left: 0em;
  position: relative;
  right: 1.1em;
  margin-top: -1.7em;
  margin-bottom: -1.3em;
}

.text-medicine {
  font-size: 0.9em;
}

.right-margin {
  margin-right: 10px;
}

button.search {
  float: right;
}

.info {
  font-size: 0.7em;
  color: #e56b1f;
}

.medicini-space {
  padding-bottom: 1em !important;
  position: relative;
  overflow: hidden;
  padding: 10px;
  border: 1px solid #eee;
  margin-bottom: 20px;
  border-radius: 4px;
}

.no-padding {
  padding: 0px !important;
}

.vs-table--content {
  margin-bottom: 50px;
}

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
  margin-top: -34px;
}

.cep {
  color: #e56b1f;
}

.pesquisa {
  position: relative;
  left: 881px;
  bottom: -61px;
}

.margin-label {
  margin-left: 20px;
}

.input-cep {
  display: flex;
  align-items: baseline;
  margin-bottom: 20px;
}

.button-search {
  position: relative;
  top: 1px;
  margin-left: 10px;
}

.button-search-location {
  position: relative;
  top: 13px;
  margin-left: 15px;
}

.labelLocation {
  position: relative;
  top: 13px;
}
</style>
